<template>
  <div class="cinema-class-detail" :class="{ 'detail-layout': !isNew }">
    <van-nav-bar
      :title="isNew ? '新建分类' : '分类详情'"
      left-text="返回"
      left-arrow
      fixed
      :placeholder="true"
      @click-left="goBack"
    >
      <template v-if="!isNew && canEdit" slot="right">
        <van-icon name="delete-o" @click="onDelete" />
      </template>
    </van-nav-bar>
    <div class="page-body" :class="{ 'has-float-add': !isNew && canEdit, 'detail-layout': !isNew }">
      <template v-if="isNew">
        <div class="form-card">
          <div class="form-card-title">
            <van-icon name="edit" size="18" color="#5b9bd5" />
            <span>基本信息</span>
          </div>
          <van-cell-group inset class="form-cells">
            <van-field
              v-model="form.name"
              label="分类名称"
              placeholder="请输入分类名称"
              required
              clearable
            />
            <van-field
              v-model="form.description"
              label="描述"
              placeholder="选填"
              clearable
            />
          </van-cell-group>
          <div class="btn-wrap">
            <van-button type="primary" block round :loading="saving" class="submit-btn" @click="submitAdd">保存</van-button>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="form-card">
          <div class="form-card-title">
            <div class="form-card-title-left">
              <van-icon name="edit" size="18" color="#5b9bd5" />
              <span>基本信息</span>
            </div>
            <van-button v-if="canEdit" type="primary" size="small" plain class="form-card-save-btn" :loading="saving" @click="saveBasic">保存</van-button>
          </div>
          <van-cell-group v-if="canEdit" inset class="form-cells">
            <van-field
              v-model="detail.name"
              label="分类名称"
              placeholder="请输入分类名称"
              clearable
            />
            <van-field
              v-model="detail.description"
              label="描述"
              placeholder="选填"
              clearable
            />
          </van-cell-group>
          <van-cell-group v-else inset class="form-cells">
            <van-cell title="分类名称" :value="detail.name" />
            <van-cell title="描述" :value="detail.description || '无'" />
          </van-cell-group>
        </div>

        <div class="section-card">
          <div class="section-head">
            <div class="section-head-left">
              <span class="section-icon"><van-icon name="shop-o" size="18" color="#323233" /></span>
              <span class="section-title">包含影院</span>
            </div>
            <span class="section-count">{{ cinemaTotal }} 家</span>
          </div>
          <div class="cinema-search-wrap">
            <van-search
              v-model="cinemaSearchKeyword"
              placeholder="输入影院名搜索"
              shape="round"
              clearable
              background="transparent"
              show-action
              class="cinema-search"
              @search="onCinemaSearch"
            >
              <template slot="action">
                <span class="cinema-search-btn" @click.stop="onCinemaSearch">搜索</span>
              </template>
            </van-search>
          </div>
          <div class="cinema-list-scroll" :class="{ 'has-float-bar': !isNew && canEdit }" ref="cinemaListScroll" @scroll="onCinemaListScroll">
            <van-list
              v-model="cinemaLoadingMore"
              :finished="cinemaFinished"
              finished-text="没有更多了"
              :immediate-check="false"
              @load="onLoadMoreCinema"
            >
              <div class="cinema-list">
                <div
                  v-for="(item, index) in cinemaList"
                  :key="(item.cinema_id || item.id) + '-' + index"
                  class="cinema-cell-wrap"
                  :class="{ 'cinema-cell-alt': index % 2 === 1 }"
                >
                  <van-cell
                    :title="item.cinema_name || item.name || '影院' + (item.cinema_id || item.id)"
                    :label="item.city_name ? '城市：' + item.city_name : ''"
                    class="cinema-cell"
                  >
                    <template v-if="canEdit" slot="right-icon">
                      <span class="remove-btn" @click="removeCinema(item)">移除</span>
                    </template>
                  </van-cell>
                </div>
                <div v-if="cinemaList.length === 0 && !loading && !cinemaSearchKeyword" class="empty-cinema">
                  <div class="empty-cinema-icon">
                    <van-icon name="shop-o" size="44" color="#c8c9cc" />
                  </div>
                  <p class="empty-cinema-text">暂无影院</p>
                  <p class="empty-cinema-hint">点击「添加影院」将影院加入本分类</p>
                </div>
                <div v-else-if="cinemaList.length === 0 && !loading && cinemaSearchKeyword" class="empty-cinema">
                  <div class="empty-cinema-icon">
                    <van-icon name="search" size="44" color="#c8c9cc" />
                  </div>
                  <p class="empty-cinema-text">无匹配影院</p>
                  <p class="empty-cinema-hint">试试其他关键词</p>
                </div>
              </div>
              <!-- 触底加载哨兵，用于 IntersectionObserver -->
              <div v-show="!cinemaFinished && cinemaList.length > 0" ref="loadMoreSentinel" class="load-more-sentinel" />
            </van-list>
          </div>
        </div>
        <div v-if="!isNew && canEdit" class="float-add-wrap">
          <van-button type="primary" block round class="float-add-btn" @click="showAddCinema = true">
            <van-icon name="plus" size="18" style="margin-right: 6px;" />
            添加影院
          </van-button>
        </div>
      </template>
    </div>

    <!-- 添加影院弹框 -->
    <van-popup v-model="showAddCinema" position="bottom" round style="height: 72%;" class="add-cinema-popup">
      <div class="popup-header">
        <span class="popup-title">选择影院</span>
        <van-icon name="cross" class="popup-close" @click="showAddCinema = false" />
      </div>
      <div class="add-cinema-filter-row">
        <van-dropdown-menu class="add-cinema-dropdown">
          <van-dropdown-item :title="addCinemaCityTitle" ref="addCinemaCityDropdown" @open="addCinemaCityKeyword = ''">
            <div class="add-cinema-city-dropdown">
              <van-search
                v-model="addCinemaCityKeyword"
                placeholder="输入城市名"
                shape="round"
                clearable
                class="city-dropdown-search"
              />
              <div class="add-cinema-city-list">
                <div
                  v-for="(opt, idx) in filteredAddCinemaCityOptions"
                  :key="'city-' + (opt.value || '') + '-' + (opt.text || '') + '-' + idx"
                  class="add-cinema-city-option"
                  :class="{ active: addCinemaFilterCity === opt.value }"
                  @click.stop="selectAddCinemaCity(opt)"
                >
                  {{ opt.text }}
                </div>
                <div v-if="filteredAddCinemaCityOptions.length === 0" class="add-cinema-city-empty">无匹配城市</div>
              </div>
            </div>
          </van-dropdown-item>
          <van-dropdown-item
            v-model="addCinemaFilterBrand"
            :options="addCinemaBrandOptions"
            @change="onAddCinemaFilterChange"
          />
        </van-dropdown-menu>
      </div>
      <div class="popup-search-wrap">
        <van-search
          v-model="addCinemaKeyword"
          placeholder="搜索影院名称或城市"
          shape="round"
          background="transparent"
          @search="searchCinemaForAdd"
        />
      </div>
      <div class="add-cinema-list">
        <van-checkbox-group v-model="addCinemaSelected">
          <div
            v-for="(item, idx) in addCinemaOptionList"
            :key="item.id"
            class="add-cinema-item"
            :class="{ 'add-cinema-item-alt': idx % 2 === 1 }"
            @click="toggleAddCinema(item)"
          >
            <van-checkbox :name="item.id" @click.native.stop />
            <div class="add-cinema-item-content">
              <span class="add-cinema-name">{{ item.name }}</span>
              <span v-if="item.city_name" class="add-cinema-city">{{ item.city_name }}</span>
            </div>
          </div>
        </van-checkbox-group>
        <div v-if="addCinemaOptionList.length === 0 && !addCinemaLoading" class="empty-tip">
          <van-icon name="search" size="36" color="#c8c9cc" />
          <p>无匹配影院</p>
        </div>
      </div>
      <div class="popup-bottom">
        <van-button type="primary" block round class="confirm-add-btn" @click="confirmAddCinema">确定添加（{{ addCinemaSelected.length }}）</van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Api from '@/api-service'

export default {
  name: 'CinemaClassDetail',
  data() {
    return {
      classId: null,
      isNew: true,
      loading: false,
      saving: false,
      form: { name: '', description: '' },
      detail: { name: '', description: '', type: 2, editable: true, cinema_list: [] },
      cinemaList: [],
      cinemaPage: 1,
      cinemaPageSize: 20,
      cinemaTotal: 0,
      cinemaLoadingMore: false,
      _loadingMoreInProgress: false,
      showAddCinema: false,
      addCinemaKeyword: '',
      addCinemaOptionList: [],
      addCinemaSelected: [],
      addCinemaLoading: false,
      addCinemaCityOptions: [{ text: '全部城市', value: '' }],
      addCinemaBrandOptions: [{ text: '全部品牌', value: '' }],
      addCinemaFilterCity: '',
      addCinemaFilterBrand: '',
      addCinemaCityKeyword: '',
      cinemaSearchKeyword: ''
    }
  },
  computed: {
    canEdit() {
      if (this.detail.editable !== undefined) return this.detail.editable
      return this.detail.type !== 1
    },
    cinemaFinished() {
      return this.cinemaTotal > 0 && this.cinemaList.length >= this.cinemaTotal
    },
    addCinemaCityTitle() {
      if (!this.addCinemaFilterCity) return '全部城市'
      const opt = this.addCinemaCityOptions.find(o => o.value === this.addCinemaFilterCity)
      return opt ? opt.text : '全部城市'
    },
    filteredAddCinemaCityOptions() {
      const kw = (this.addCinemaCityKeyword || '').trim().toLowerCase()
      if (!kw) return this.addCinemaCityOptions
      return this.addCinemaCityOptions.filter(o => o.text && o.text.toLowerCase().includes(kw))
    }
  },
  created() {
    const id = this.$route.params.id
    const isNewRoute = id === 'new' || this.$route.name === 'CinemaClassNew' || this.$route.path === '/cinema-class/new'
    if (isNewRoute) {
      this.isNew = true
      return
    }
    this.isNew = false
    this.classId = parseInt(id, 10)
    this.fetchDetail()
  },
  mounted() {
    if (!this.isNew) {
      this.$nextTick(() => this.setupScrollObserver())
    }
  },
  beforeDestroy() {
    if (this._scrollObserver && this.$refs.cinemaListScroll) {
      this._scrollObserver.disconnect()
      this._scrollObserver = null
    }
  },
  methods: {
    goBack() {
      this.$router.back()
    },
    fetchDetail(page = 1, name) {
      if (page === 1) {
        this.loading = true
        this.cinemaList = []
        this.cinemaPage = 1
      } else {
        if (this._loadingMoreInProgress) return
        this._loadingMoreInProgress = true
        this.cinemaLoadingMore = true
      }
      const params = { id: this.classId, page, pageSize: this.cinemaPageSize }
      if (name !== undefined && name !== null && String(name).trim() !== '') {
        params.name = String(name).trim()
      }
      Api.getCinemaClassDetail(params)
        .then(res => {
          const d = res.data || res
          this.detail = {
            name: d.name || '',
            description: d.description || '',
            type: d.type,
            editable: d.editable
          }
          const list = (d.cinema_list || []).map(c => ({
            cinema_id: c.cinema_id,
            id: c.cinema_id,
            cinema_name: c.cinema_name,
            name: c.cinema_name,
            city_name: c.city_name || ''
          }))
          if (page === 1) {
            this.cinemaList = list
          } else {
            this.cinemaList.push(...list)
          }
          this.cinemaTotal = d.cinema_total != null ? d.cinema_total : 0
          this.cinemaPage = page
          if (page === 1) {
            this.$nextTick(() => {
              this.checkAndLoadMoreCinema()
              this.setupScrollObserver()
            })
          }
        })
        .catch(() => {
          if (page === 1) this.$toast.fail('加载失败')
          else this.$toast.fail('加载更多失败')
        })
        .finally(() => {
          this.loading = false
          this.cinemaLoadingMore = false
          this._loadingMoreInProgress = false
        })
    },
    onCinemaSearch() {
      if (this.isNew || this.classId == null) return
      const name = (this.cinemaSearchKeyword || '').trim() || undefined
      this.fetchDetail(1, name)
    },
    onLoadMoreCinema() {
      if (this.loading || this._loadingMoreInProgress) return
      if (this.cinemaTotal > 0 && this.cinemaList.length >= this.cinemaTotal) return
      const name = (this.cinemaSearchKeyword || '').trim() || undefined
      this.fetchDetail(this.cinemaPage + 1, name)
    },
    onCinemaListScroll() {
      const el = this.$refs.cinemaListScroll
      if (!el || this.cinemaFinished || this.cinemaLoadingMore || this.loading) return
      const { scrollTop, scrollHeight, clientHeight } = el
      const distanceToBottom = scrollHeight - scrollTop - clientHeight
      if (distanceToBottom < 100) {
        this.onLoadMoreCinema()
      }
    },
    checkAndLoadMoreCinema() {
      const el = this.$refs.cinemaListScroll
      if (!el || this.cinemaFinished || this._loadingMoreInProgress || this.loading) return
      const { scrollTop, scrollHeight, clientHeight } = el
      if (scrollHeight <= clientHeight || scrollHeight - scrollTop - clientHeight < 100) {
        this.onLoadMoreCinema()
      }
    },
    setupScrollObserver() {
      const root = this.$refs.cinemaListScroll
      const sentinel = this.$refs.loadMoreSentinel
      if (!root || !sentinel || this._scrollObserver) return
      this._scrollObserver = new IntersectionObserver(
        entries => {
          if (!entries.length || !entries[0].isIntersecting) return
          this.onLoadMoreCinema()
        },
        { root, rootMargin: '0px 0px 80px 0px', threshold: 0 }
      )
      this._scrollObserver.observe(sentinel)
    },
    submitAdd() {
      const name = (this.form.name || '').trim()
      if (!name) {
        this.$toast('请输入分类名称')
        return
      }
      this.saving = true
      Api.addCinemaClass({ name, desc: (this.form.description || '').trim() })
        .then(res => {
          const id = (res && res.data && res.data.id) || (res && res.id)
          this.$toast.success('创建成功')
          if (id) {
            this.$router.replace(`/cinema-class/${id}`)
            this.isNew = false
            this.classId = id
            this.fetchDetail()
          } else {
            this.$router.replace('/cinema-class')
          }
        })
        .catch(() => {
          this.$toast.fail('创建失败')
        })
        .finally(() => {
          this.saving = false
        })
    },
    saveBasic() {
      const name = (this.detail.name || '').trim()
      if (!name) {
        this.$toast('请输入分类名称')
        return
      }
      this.saving = true
      Api.updateCinemaClass({
        id: this.classId,
        name,
        description: (this.detail.description || '').trim()
      })
        .then(() => {
          this.$toast.success('保存成功')
        })
        .catch(() => {
          this.$toast.fail('保存失败')
        })
        .finally(() => {
          this.saving = false
        })
    },
    onDelete() {
      this.$dialog
        .confirm({
          title: '确认删除',
          message: '确定删除该分类吗？'
        })
        .then(() => {
          Api.deleteCinemaClass({ id: this.classId }).then(() => {
            this.$toast.success('已删除')
            this.$router.replace('/cinema-class')
          }).catch(() => {
            this.$toast.fail('删除失败')
          })
        })
        .catch(() => {})
    },
    loadAddCinemaFilterOptions() {
      Api.getProvinceCityList({}).then(res => {
        const list = res.list || []
        const cityOpts = [{ text: '全部城市', value: '' }]
        list.forEach(prov => {
          (prov.city_list || []).forEach(c => {
            cityOpts.push({ text: c.name, value: c.city_code || c.id || '' })
          })
        })
        this.addCinemaCityOptions = cityOpts
      }).catch(() => {})
      Api.getGpLineList({}).then(res => {
        const list = res.list || []
        const brandOpts = [{ text: '全部品牌', value: '' }]
        list.forEach(el => {
          brandOpts.push({ text: el.name, value: el.ID != null ? el.ID : el.id })
        })
        this.addCinemaBrandOptions = brandOpts
      }).catch(() => {})
    },
    onAddCinemaFilterChange() {
      this.searchCinemaForAdd()
    },
    selectAddCinemaCity(opt) {
      this.addCinemaFilterCity = opt.value
      this.searchCinemaForAdd()
      this.$nextTick(() => {
        const ref = this.$refs.addCinemaCityDropdown
        if (ref && ref.toggle) ref.toggle(false)
      })
    },
    searchCinemaForAdd() {
      const kw = (this.addCinemaKeyword || '').trim()
      this.addCinemaLoading = true
      const data = { page: 1, pageSize: 100, name: kw || undefined }
      if (this.addCinemaFilterCity) {
        data.city_codes = this.addCinemaFilterCity
      }
      if (this.addCinemaFilterBrand !== '' && this.addCinemaFilterBrand != null) {
        data.line_id = Number(this.addCinemaFilterBrand)
      }
      Api.getCinemaList(data)
        .then(res => {
          const list = (res && res.list) || []
          const existingIds = new Set(this.cinemaList.map(c => Number(c.cinema_id || c.id)))
          this.addCinemaOptionList = list
            .map(el => ({ id: el.ID || el.id, name: el.name, city_name: el.city_name }))
            .filter(el => !existingIds.has(Number(el.id)))
        })
        .finally(() => {
          this.addCinemaLoading = false
        })
    },
    toggleAddCinema(item) {
      const idx = this.addCinemaSelected.indexOf(item.id)
      if (idx === -1) {
        this.addCinemaSelected.push(item.id)
      } else {
        this.addCinemaSelected.splice(idx, 1)
      }
    },
    confirmAddCinema() {
      if (this.addCinemaSelected.length === 0) {
        this.$toast('请选择影院')
        return
      }
      Api.addCinemaToClass({ class_id: this.classId, cinema_ids: this.addCinemaSelected })
        .then(() => {
          this.showAddCinema = false
          this.fetchDetail(1)
        })
        .catch(() => {
          this.$toast.fail('添加失败')
        })
    },
    removeCinema(item) {
      const id = item.cinema_id || item.id
      this.$dialog
        .confirm({
          title: '确认移除',
          message: '确定从本分类中移除该影院吗？'
        })
        .then(() => {
          Api.removeCinemaFromClass({ class_id: this.classId, cinema_ids: [id] })
            .then(() => {
              this.$toast.success('已移除')
              this.fetchDetail(1)
            })
            .catch(() => {
              this.$toast.fail('移除失败')
            })
        })
        .catch(() => {})
    }
  },
  watch: {
    showAddCinema(v) {
      if (v) {
        this.addCinemaKeyword = ''
        this.addCinemaFilterCity = ''
        this.addCinemaFilterBrand = ''
        this.addCinemaCityKeyword = ''
        this.addCinemaOptionList = []
        this.addCinemaSelected = []
        this.loadAddCinemaFilterOptions()
        this.searchCinemaForAdd()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.cinema-class-detail {
  min-height: 100vh;
  background: #f8f8f8;
  font-family: -apple-system, BlinkMacSystemFont, 'PingFang SC', 'Helvetica Neue', sans-serif;
}
/* 详情页：整体不滚动，只有影院列表区域滚动 */
.cinema-class-detail.detail-layout {
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.cinema-class-detail.detail-layout .page-body {
  flex: 1;
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding-bottom: 0;
}
.cinema-class-detail.detail-layout .page-body.has-float-add {
  padding-bottom: 0;
}
.cinema-class-detail.detail-layout .form-card {
  flex-shrink: 0;
}
.cinema-class-detail.detail-layout .section-card {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.cinema-class-detail.detail-layout .section-card .section-head {
  flex-shrink: 0;
}
.cinema-list-scroll {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.cinema-list-scroll.has-float-bar {
  padding-bottom: 72px;
}
.cinema-list-scroll .cinema-list {
  background: #fff;
}
.cinema-list-scroll .cinema-cell ::v-deep .van-cell {
  padding: 14px 16px;
  font-size: 14px;
}
.cinema-list-scroll .cinema-cell ::v-deep .van-cell::after {
  border-color: #f5f5f5;
}
.cinema-list-scroll .cinema-cell ::v-deep .van-cell__label {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}
.cinema-list-loading {
  padding: 12px 0;
  font-size: 12px;
  color: #969799;
  text-align: center;
}
.load-more-sentinel {
  height: 1px;
  width: 100%;
  pointer-events: none;
  visibility: hidden;
}
.page-body {
  padding: 16px 0 32px;
}
.page-body.has-bottom-save {
  padding-bottom: calc(90px + env(safe-area-inset-bottom, 0px));
}
.page-body.has-float-add {
  padding-bottom: calc(80px + env(safe-area-inset-bottom, 0px));
}
.float-add-wrap {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 12px 16px 16px;
  padding-bottom: calc(12px + env(safe-area-inset-bottom, 0px));
  background: linear-gradient(to top, #fff 60%, rgba(255, 255, 255, 0.95));
  z-index: 100;
}
.float-add-btn {
  height: 44px;
  font-size: 16px;
  font-weight: 500;
  box-shadow: 0 2px 8px rgba(25, 137, 250, 0.3);
}
.form-card {
  margin: 0 16px 16px;
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}
.form-card-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  font-size: 15px;
  font-weight: 600;
  color: #333;
  background: #fafafa;
}
.form-card-title-left {
  display: flex;
  align-items: center;
  gap: 8px;
}
.form-card-title .van-icon {
  color: #5b9bd5;
}
.form-card-save-btn {
  flex-shrink: 0;
  height: 28px;
  padding: 0 12px;
  font-size: 13px;
  color: #1989fa !important;
  border-color: #1989fa !important;
}
.form-card-save-btn ::v-deep .van-button__text {
  color: #1989fa !important;
}
.form-card .form-cells ::v-deep .van-cell-group--inset {
  margin: 0;
  border-radius: 0;
}
.form-card ::v-deep .van-field__control {
  text-align: right;
}
.form-card ::v-deep .van-cell {
  padding: 12px 16px;
}
.form-card ::v-deep .van-cell::after {
  border-color: #f5f5f5;
}
.btn-wrap {
  padding: 20px 16px 16px;
}
.submit-btn {
  height: 46px;
  font-size: 16px;
  font-weight: 500;
}
.section-card {
  margin: 0 16px;
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}
.section-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px 12px;
  background: #fafafa;
}
.section-head-left {
  display: flex;
  align-items: center;
  gap: 8px;
}
.section-head .section-icon .van-icon {
  color: #323233 !important;
}
.section-head .section-title {
  font-size: 15px;
  font-weight: 600;
  color: #323233 !important;
}
.section-head .section-count {
  font-size: 13px;
  color: #323233 !important;
  font-weight: 500;
}
.cinema-search-wrap {
  padding: 0 0 6px 0;
  background: #fafafa;
}
.cinema-search-wrap .cinema-search {
  padding: 0;
}
.cinema-search-wrap ::v-deep .van-search__content {
  background: #fff;
  border-radius: 8px;
  min-height: 32px;
  display: flex;
  align-items: center;
  padding-left: 0;
}
.cinema-search-wrap ::v-deep .van-field__body {
  padding: 4px 10px 4px 8px;
  min-height: 32px;
}
.cinema-search-wrap ::v-deep .van-field__control {
  line-height: 1.4;
  font-size: 14px;
}
.cinema-search-wrap ::v-deep .van-field__left-icon {
  display: flex;
  align-items: center;
  margin-right: 6px;
  padding-left: 16px;
}
.cinema-search-wrap ::v-deep .van-field__left-icon .van-icon {
  vertical-align: middle;
}
.cinema-search-wrap ::v-deep .van-search__action {
  padding: 0 16px 0 8px;
  flex-shrink: 0;
}
.cinema-search-btn {
  color: #1989fa;
  font-size: 14px;
  padding: 0 4px;
  white-space: nowrap;
}
.cinema-list-wrap {
  background: #fff;
  min-height: 120px;
}
.cinema-list-wrap ::v-deep .van-list__finished-text,
.cinema-list-wrap ::v-deep .van-list__loading {
  padding: 12px 0;
  font-size: 12px;
  color: #969799;
}
.cinema-cell-wrap {
  background: #fff;
}
.cinema-cell-wrap.cinema-cell-alt {
  background: #fafafa;
}
.cinema-list-wrap .cinema-cell ::v-deep .van-cell {
  padding: 14px 16px;
  font-size: 14px;
}
.cinema-list-wrap .cinema-cell ::v-deep .van-cell::after {
  border-color: #f5f5f5;
}
.cinema-list-wrap .cinema-cell ::v-deep .van-cell__label {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}
.remove-btn {
  font-size: 13px;
  color: #ee0a24;
  padding: 4px 10px;
  margin-right: -8px;
}
.empty-cinema {
  padding: 40px 20px;
  text-align: center;
}
.empty-cinema-icon {
  width: 64px;
  height: 64px;
  margin: 0 auto 16px;
  background: #f5f5f5;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.empty-cinema-icon .van-icon {
  color: #ccc;
}
.empty-cinema-text {
  font-size: 15px;
  font-weight: 500;
  color: #333;
  margin: 0 0 6px;
}
.empty-cinema-hint {
  font-size: 13px;
  color: #999;
  margin: 0;
}
.add-cinema-popup {
  display: flex;
  flex-direction: column;
}
.popup-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 16px 14px;
  background: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}
.popup-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
}
.popup-close {
  padding: 6px;
  font-size: 20px;
  color: #999;
}
.add-cinema-filter-row {
  background: #fff;
  padding: 0;
}
.add-cinema-dropdown ::v-deep .van-dropdown-menu__bar {
  height: 44px;
  box-shadow: none;
  border-bottom: 1px solid #ebedf0;
}
.add-cinema-dropdown ::v-deep .van-dropdown-item__title {
  font-size: 14px;
  color: #323233;
}
.add-cinema-city-dropdown {
  background: #fff;
  padding: 0;
  max-height: 320px;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 10;
}
.add-cinema-city-dropdown .city-dropdown-search {
  flex-shrink: 0;
  padding: 8px;
}
.add-cinema-city-dropdown .city-dropdown-search ::v-deep .van-search__content {
  background: #f7f8fa;
  border-radius: 8px;
}
.add-cinema-city-list {
  flex: 1;
  overflow-y: auto;
  max-height: 260px;
  padding: 0 8px 8px;
  position: relative;
  z-index: 2;
  -webkit-overflow-scrolling: touch;
}
.add-cinema-city-option {
  padding: 12px 12px;
  font-size: 14px;
  color: #323233;
  border-radius: 6px;
  cursor: pointer;
  user-select: none;
}
.add-cinema-city-option:active {
  background: #f2f3f5;
}
.add-cinema-city-option.active {
  color: #1989fa;
  background: #ecf9ff;
}
.add-cinema-city-empty {
  padding: 24px;
  text-align: center;
  font-size: 14px;
  color: #969799;
}
.popup-search-wrap {
  padding: 10px 16px 12px;
  background: #f8f8f8;
}
.popup-search-wrap ::v-deep .van-search {
  padding: 0;
}
.popup-search-wrap ::v-deep .van-search__content {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}
.add-cinema-list {
  flex: 1;
  overflow-y: auto;
  padding-bottom: 80px;
  background: #fff;
}
.add-cinema-item {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  gap: 12px;
  min-height: 56px;
  box-sizing: border-box;
}
.add-cinema-item-alt {
  background: #fafafa;
}
.add-cinema-item-content {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.add-cinema-name {
  font-size: 14px;
  font-weight: 500;
  color: #333;
}
.add-cinema-city {
  font-size: 12px;
  color: #999;
}
.popup-bottom {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 12px 16px;
  padding-bottom: calc(12px + env(safe-area-inset-bottom));
  background: #fff;
  box-shadow: 0 -1px 3px rgba(0, 0, 0, 0.05);
}
.confirm-add-btn {
  height: 48px;
  font-size: 16px;
  font-weight: 500;
}
.empty-tip {
  padding: 40px 16px;
  text-align: center;
  color: #999;
  font-size: 14px;
}
.empty-tip .van-icon {
  display: block;
  margin: 0 auto 12px;
  opacity: 0.7;
}
.empty-tip p {
  margin: 0;
}

/* 与订单池统一的卡片、字号与主操作色 */
.cinema-class-detail {
  background: var(--merchant-canvas);
}
.form-card,
.section-card {
  border: 1px solid var(--merchant-line);
  border-radius: var(--merchant-radius);
  box-shadow: var(--merchant-shadow);
}
.form-card-title,
.section-head .section-title,
.popup-title {
  color: var(--merchant-ink) !important;
  font-size: 14px;
  font-weight: 650;
}
.form-card-title .van-icon,
.form-card-title-left .van-icon,
.section-head .section-icon .van-icon {
  color: var(--merchant-brand) !important;
}
.section-head .section-count,
.cinema-cell ::v-deep .van-cell__label,
.add-cinema-city,
.empty-cinema-hint {
  color: var(--merchant-muted) !important;
}
.cinema-cell ::v-deep .van-cell__title,
.add-cinema-name {
  color: var(--merchant-ink);
  font-size: 14px;
  font-weight: 600;
}
.cinema-cell-wrap.cinema-cell-alt,
.add-cinema-item-alt,
.cinema-search-wrap,
.popup-search-wrap {
  background: #f8f9fc;
}
.cinema-search-wrap ::v-deep .van-search__content,
.popup-search-wrap ::v-deep .van-search__content {
  border: 1px solid var(--merchant-line);
  box-shadow: none;
}
.cinema-search-btn,
.form-card-save-btn {
  color: var(--merchant-brand) !important;
}
.float-add-wrap,
.popup-bottom {
  border-top: 1px solid var(--merchant-line);
  box-shadow: 0 -8px 24px rgba(28, 42, 68, 0.06);
}
.float-add-btn,
.submit-btn,
.confirm-add-btn {
  border-color: var(--merchant-brand) !important;
  background: var(--merchant-brand) !important;
  box-shadow: none;
}
.remove-btn {
  color: var(--merchant-accent);
}
</style>
